
const FlowingPageFootnoteWrapper = (props) => {
    const { children, attributes, flowStyles, element } = props
    const style = {}
    style.marginTop = element.marginTop + 'pt'

    const fnDividerName = flowStyles['footnoteDivider'];
    const dividerStyles = props.styles[fnDividerName]

    return (
        <div {...attributes}
            className='footnote-wrapper'
            style={{ ...style }}
        >
            <div
                className="footnote-wrapper-divider"
                style={{
                    width: dividerStyles ? dividerStyles.width + "pt" : '158pt',
                    borderTop: dividerStyles ? dividerStyles.height + "pt solid " + dividerStyles.color : '1pt solid black',
                    marginBottom: dividerStyles ? dividerStyles.paddingBelowParagraph + 'pt' : '3pt',
                    userSelect: 'none',
                    pointerEvents: 'none'
                }}>
            </div>
            {children}
        </div>
    )
}

export default FlowingPageFootnoteWrapper;